import { Component, OnInit, Input, Self, Optional } from '@angular/core';
import { FormGroup, NgControl } from '@angular/forms';
// import { ThirdPartyEvaluationFormItem } from '../../../models/thirdparty-evaluation-form-item';
import { BehaviorSubject } from 'rxjs';
// import { answerGrid, formsCompletedAnswer, formsCompletedAnswerGridItem, formsCompletedAnswerGridItemTotal } from '../../../models/thirdparty-evaluation-status';
import { ColumnTypes } from '@app/enums/column-types.enum';
import { MatDialog } from '@angular/material/dialog';
import { DatasourcesService } from '@app/services/datasources.service';
import { NotificationService } from '@app/services/notification.service';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { evaluate, isNumber } from '@app/utils/common-functions';
import { BaseAnswerTypeComponent } from '../base-answer-type.component';
import { ComparableOperator } from '@app/models/form';
import { TableInputColumnValue } from '../table-input/table-input.component';
import { ItemRecordColumn } from '@app/models/item-record-columns';
import { AnswerGrid } from '@app/models/thirdparty-evaluation-status';
import { formsCompletedAnswerGridItem, formsCompletedAnswerGridItemTotal } from '@app/models/survey/survey-item';

export interface NumericColumn {
  orderColumn: number, referenceColumn: string
}

@Component({
  selector: 'app-record-type-question-input',
  templateUrl: './record-type-question.component.html',
  styleUrls: ['./record-type-question.component.scss']
})
export class RecordTypeQuestionInputComponent extends BaseAnswerTypeComponent<AnswerGrid> implements OnInit {

  recordColumns$: BehaviorSubject<ItemRecordColumn[]>;
  get recordColumns(): any {
    return this.recordColumns$.getValue();
  }
  @Input() set recordColumns(value: ItemRecordColumn[]) {
    this.recordColumns$.next(value);
  }

  @Input() readonly: boolean = true;

  _formsCompletedAnswerGridItem$: BehaviorSubject<AnswerGrid>;

  columnsSchema: ItemRecordColumn[] = [];

  columnTypesEnum = ColumnTypes;

  displayedColumns: string[] = [];
  displayedTotalColumns: string[] = [];
  dataSource: MatTableDataSource<any>;

  recordTypeData: any[] = [];
  numericColumns: NumericColumn[] = [];
  calculatedColumns: { orderColumn: number, numericColumns: NumericColumn[] }[] = [];

  constructor(
    private dataSourceService: DatasourcesService,
    private notificationService: NotificationService,
    private translate: TranslateService,
    @Self() @Optional() ngControl?: NgControl
  ) {
    super(ngControl);
    this._formsCompletedAnswerGridItem$ = new BehaviorSubject<AnswerGrid>(null);
    this.recordColumns$ = new BehaviorSubject<ItemRecordColumn[]>([]);
    this.dataSource = new MatTableDataSource<any>();

    // if (this.ngControl) {
    //   this.ngControl.valueChanges.subscribe(value => console.log(value));
    // }
    
  }

  ngOnInit() {

    // Sete inicial de datos

    this._formsCompletedAnswerGridItem$.subscribe({
      next: gridAnswers => {
        this.updateValue(gridAnswers);
        if (gridAnswers && gridAnswers.gridItem) {
          let controlErrorFlag = gridAnswers.gridItem.some(item => item.value == '' || item.value == undefined || item.value == null);
          let controlError = controlErrorFlag ? {rowIncomplete: true} : null;
          this.ngControl.control.setErrors(controlError);
        }
      }
    });

      const isEditColumn: ItemRecordColumn = {
        id: -1,
        title: 'isEdit',
        columnTypeId: -1,
        columnOrder: 1000,
        useVerticalTotalizer: false,
      };

      this.columnsSchema = this.recordColumns.sort((n1, n2) => n1.columnOrder - n2.columnOrder);
      this.columnsSchema.push(isEditColumn);
      this.checkDuplicatedActionColumn(isEditColumn);

      this.displayedColumns = this.columnsSchema.map((col) => 'column_' + col.id);
      this.displayedTotalColumns = this.columnsSchema.filter(col => col.useVerticalTotalizer).map((col) => 'column_' + col.id);
      if(!this.readonly) this.addRow();

      // We iterate the columns once for setting up the numericColumns and recordTypeData arrays 
      this.columnsSchema.forEach(column => {
        if (column.columnTypeId == this.columnTypesEnum.Numeric ||
          column.columnTypeId == this.columnTypesEnum.RecordTypeAutocomplete) {
          this.numericColumns.push({
            orderColumn: column.columnOrder,
            referenceColumn: '{{column_' + column.columnOrder + '}}'
          })
        }
        if (column.columnTypeId == this.columnTypesEnum.RecordTypeSelect ||
          column.columnTypeId == this.columnTypesEnum.RecordTypeAutocomplete) {

          const currentRecordTypeData = this.recordTypeData[column.recordTypeId];
          if (currentRecordTypeData == null || currentRecordTypeData == undefined || !currentRecordTypeData.length) {

            this.dataSourceService.getRecordTypeData(column.recordTypeId).subscribe(response => {
              this.recordTypeData[column.recordTypeId] = response;
            },
              err => this.notificationService.openSnackBar(err));
          }
          
        }
      });
      // We iterate the columns a 2nd time for setting up the calculatedColumns array, otherwise ahead numeric columns would be missing
      this.columnsSchema.forEach(column => {
        if (column.columnTypeId == this.columnTypesEnum.Calculated) {
          const formula = column.formula;
          let numericCols: NumericColumn[] = this.numericColumns.filter(col => formula.includes(col.referenceColumn));
          this.calculatedColumns.push({
            orderColumn: column.columnOrder,
            numericColumns: numericCols
          });
        }
      });

    // });

  }

  writeValue(obj: AnswerGrid): void {
    super.writeValue(obj);
    if (obj && this.recordColumns) {
      this.setDataSource(obj.gridItem);
    }
  }

  checkDuplicatedActionColumn(actionCol: ItemRecordColumn): void {
    if (this.columnsSchema.filter(col => 
        col.columnTypeId == actionCol.columnTypeId || col.id == actionCol.id).length > 1) {
      this.columnsSchema = [...this.columnsSchema.filter(col => 
          col.columnTypeId != actionCol.columnTypeId || col.id != actionCol.id)];
    this.columnsSchema.push(actionCol);
    }
  }

  addRow() {
    const newRow = {
      isEdit: true,
    };
    this.dataSource.data = [newRow, ...this.dataSource.data];
  }

  removeRow(id) {
    this.dataSource.data.splice(id, 1);
    this.dataSource.data = [...this.dataSource.data];
    this.setAnswerGridItems();
  }

  setAnswerGridItems() {
    let gridAnswers: AnswerGrid = new AnswerGrid();

    const formItem = this.recordColumns;
    if (formItem && this.dataSource) {
      let iRow = 0;
      this.dataSource.data
      .filter(row => Object.keys(row).length && (!row.hasOwnProperty('isEdit') || (row.hasOwnProperty('isEdit') && !row.isEdit)))
      .forEach(row => {
        formItem.forEach((col: ItemRecordColumn) => {
          if (col.id > 0) {
            let cellValue = row[col.columnOrder];
            if (cellValue && col.columnTypeId == this.columnTypesEnum.RecordTypeSelect) {
              cellValue = cellValue[col.recordField.toLowerCase()];
            }
            const newGridItem: formsCompletedAnswerGridItem = {
              id: 0,
              columnId: col.id,
              rowNumber: iRow,
              value: cellValue ? String(cellValue) : ''
            };
            gridAnswers.gridItem.push(newGridItem);
            if (col.useVerticalTotalizer) {
              const totalItem = gridAnswers.gridItemTotals.filter(x => x.columnId == col.id);
              if (!totalItem || totalItem.length < 1) {
                const newRowTotalItem: formsCompletedAnswerGridItemTotal = {
                  id: 0,
                  columnId: col.id,
                  value: String(cellValue)
                };
                gridAnswers.gridItemTotals.push(newRowTotalItem);
              } else {
                totalItem[0].value = String(Number(totalItem[0].value) + Number(cellValue));
              }
            }
          }
        });
        iRow++;
      });
    }

    if (gridAnswers.gridItem.length == 0) {
      gridAnswers = null;
    }

    this._formsCompletedAnswerGridItem$.next(gridAnswers);
  }

  setDataSource(gridItems: formsCompletedAnswerGridItem[]) {
    
    let maxRowNumber = Math.max(...gridItems.map(o => o.rowNumber));
    const recordColumns = this.recordColumns;
    for (let i = 0; i <= maxRowNumber; i++) {
      let item = {};
      var columnsValues = gridItems.filter(x => x.rowNumber == i);
      if (columnsValues) {
        columnsValues.forEach(columnValue => {
          let recordColumn = recordColumns.find(x => x.id == columnValue.columnId);
          if (recordColumn) {
            if (recordColumn && recordColumn.columnTypeId == this.columnTypesEnum.RecordTypeSelect) {
              var data = {}
              data[recordColumn.recordField.toLowerCase()] = columnValue.value;
              item['' + recordColumn.columnOrder + ''] = data;
            } else {
              item['' + recordColumn.columnOrder + ''] = columnValue.value;
            }
          }
        });
      }
      this.dataSource.data.push(item);
    }
    this.setAnswerGridItems();
  }

  saveRow(element) {
    element.isEdit = !element.isEdit;
    this.setAnswerGridItems();
  }

  cantSaveRow(element): boolean {
    return this.columnsSchema.some(col => col.id > 0 && (element[col.columnOrder] === '' || element[col.columnOrder] === null || element[col.columnOrder] === undefined));
  }

  getAutoCompleteValue(element: any, column: ItemRecordColumn): any {

    if (!element[column.recordTypeAutocompleteReference] || !column.recordField) {
      return null;
    }

    const recordTypeData = this.recordTypeData[column.recordTypeId].find(x => x.id == element[column.recordTypeAutocompleteReference].id);
    element[column.columnOrder] = recordTypeData ? recordTypeData[column.recordField.toLowerCase()] : null;

    return element[column.columnOrder];
  }

  getCalculated(element: any, column: ItemRecordColumn): any {
    if (column.columnTypeId != this.columnTypesEnum.Calculated || !column.formula) return;
    if (!this.numericColumns || !this.numericColumns.length ||
      !this.calculatedColumns || !this.calculatedColumns.length) return null;


    const numericCols: NumericColumn[] = this.calculatedColumns.find(col => col.orderColumn == column.columnOrder).numericColumns;
    let formatedFormula = column.formula;

    numericCols.forEach(numCol => {
      if (column.formula.includes(numCol.referenceColumn)) {
        const value = element[numCol.orderColumn];
        let replacement = value && isNumber(value) ? element[numCol.orderColumn] : 0;
        const regex = new RegExp(numCol.referenceColumn,"g");
        formatedFormula = formatedFormula.replace(regex, replacement);
      }
    });
    if (formatedFormula.includes('{{column_')) {
      element[column.columnOrder] = this.translate.instant('THIRDPARTY.RECORD_TYPE_QUESTION.CALCULATED_ERROR');
    } else {
      element[column.columnOrder] = evaluate(formatedFormula);
    }
    return element[column.columnOrder];
  }

  getRecordField(answer, recordField: string): string {
    return answer ? answer[recordField.toLowerCase()] : answer;
  }

  getrecordTypeDataFiltered(recordTypeId: number, recordField: string): any[] {
    return this.recordTypeData[recordTypeId].filter(record => record[recordField.toLowerCase()] !== null && 
      record[recordField.toLowerCase()] !== undefined && record[recordField.toLowerCase()] !== '');
  }

  thereIsTotalizer(): boolean {
    return this.columnsSchema.some(col => col.useVerticalTotalizer);
  }

  calculateTotal(column: ItemRecordColumn) {
    const result = this.dataSource.data.reduce((accum, curr) => accum +
      (Number(curr[column.columnOrder]) === undefined ? 0 : Number(curr[column.columnOrder])), 0);

    return isNaN(result) ? 0 : result;
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  checkIfSomeRowIsEdit(): boolean {
    return this.dataSource.data.some(row => row.isEdit);
  }

  AllowedOperators: {[K in ComparableOperator]: (target: AnswerGrid, value: string) => boolean} = {
    [ComparableOperator.Equal]: null,
    [ComparableOperator.NotEqual]: null,
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: null,
    [ComparableOperator.GreaterThan]: (t, value) => t?.getUniqueRowNumbersLength > +value,
    [ComparableOperator.GreaterThanOrEqual]: (t, value) => t?.getUniqueRowNumbersLength >= +value,
    [ComparableOperator.LessThan]: (t, value) => t?.getUniqueRowNumbersLength < +value,
    [ComparableOperator.LessThanOrEqual]: (t, value) => t?.getUniqueRowNumbersLength <= +value,
    [ComparableOperator.IsNullOrEmpty]: (t) => !(t?.getUniqueRowNumbersLength),
    [ComparableOperator.NotIsNullOrEmpty]: (t) => !!t?.getUniqueRowNumbersLength,
    [ComparableOperator.Between]: null,
  }
}